import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';

export const handleCommonResponseInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    map((event) => {
      if (!(event instanceof HttpResponse)) {
        return event;
      }

      const body = event.body;
      if (!body || typeof body !== 'object' || Array.isArray(body)) {
        return event;
      }

      const envelope = body as {
        success?: boolean;
        data?: unknown;
        errors?: unknown;
        statusCode?: number;
      };

      const hasEnvelopeShape =
        'success' in envelope || 'data' in envelope || 'errors' in envelope || 'statusCode' in envelope;

      if (!hasEnvelopeShape) {
        return event;
      }

      const statusCode = envelope.statusCode ?? event.status;
      if (envelope.success === false || envelope.errors != null || statusCode >= 400) {
        throw new HttpErrorResponse({
          error: envelope,
          status: statusCode,
          statusText: event.statusText,
          url: event.url ?? undefined,
        });
      }

      return 'data' in envelope ? event.clone({ body: envelope.data }) : event;
    }),
  );
